import { scanResult } from 'routes/AppUrls';
import {
  ACTIVE_INDEX_ADMIN,
  REQUEST_ID,
  REQUEST_VALUE,
  PROVIDER_ID,
  PRACTICE_DETAIL_ID,
  PATIENT_ID,
  QUESTIONAIRE_ID,
  LOGIN_DETAILS,
  SCAN_DETAILS,
  SCAN_RESULT,
  PARTICULAR_ENTERPRISE,
  PARTICULAR_STAFF,
  PARTICULAR_LEAD_CAPTURE,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';

const initialState = {
  adminActiveIndex: 0,
  requestDetailId: '',
  requestDetailValue: '',
  providerId: '',
  practiceValueId: '',
  patientId: '',
  questionnaireId: '',
  loginDetails: null,
  scanDetails: null,
  scanResult: null,
  particularEnterprise: null,
  particularStaff: null,
  particularLeadCapture: null,
};

const basicDetailsValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_INDEX_ADMIN:
      return {
        ...state,
        adminActiveIndex: action.payload,
      };
    case REQUEST_ID:
      return {
        ...state,
        requestDetailId: action.payload,
      };
    case REQUEST_VALUE:
      return {
        ...state,
        requestDetailValue: action.payload,
      };
    case PROVIDER_ID:
      return {
        ...state,
        providerId: action.payload,
      };
    case PRACTICE_DETAIL_ID:
      return {
        ...state,
        practiceValueId: action.payload,
      };
    case PATIENT_ID:
      return {
        ...state,
        patientId: action.payload,
      };
    case QUESTIONAIRE_ID:
      return {
        ...state,
        questionnaireId: action.payload,
      };
    case LOGIN_DETAILS:
      return {
        ...state,
        loginDetails: action.payload,
      };
    case SCAN_DETAILS:
      return {
        ...state,
        scanDetails: action.payload,
      };
    case SCAN_RESULT:
      return {
        ...state,
        scanResult: action.payload,
      };
    case PARTICULAR_ENTERPRISE:
      return {
        ...state,
        particularEnterprise: action.payload,
      };
    case PARTICULAR_STAFF:
      return {
        ...state,
        particularStaff: action.payload,
      };
    case PARTICULAR_LEAD_CAPTURE:
      return {
        ...state,
        particularLeadCapture: action.payload,
      };
    default:
      return state;
  }
};

export default basicDetailsValueReducer;
